import{jsx as e}from"react/jsx-runtime";import{styled as n}from"styled-components";import{useRowSelection as r}from"./RowSelectionContext.mjs";import{FIRST_COL_WIDTH as t}from"./constants.mjs";const o=n.label`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  inset: 0;
  margin-inline-end: 1px;
`,l=n.input.attrs({readOnly:!0,type:"checkbox"})`
  cursor: pointer;
`;function i(){const n=r();return e(o,{children:e(l,{...n})})}function s(){const n=r();return e(o,{onClick:e=>e.stopPropagation(),children:e(l,{...n})})}const d={displayName:"",width:t,renderHeaderCell:()=>e(i,{}),renderCell:()=>e(s,{})},a={displayName:"",width:t,renderHeaderCell:()=>null,renderCell:({rowIndex:e})=>e+1},c={displayName:"",width:t,renderHeaderCell:()=>null,renderCell:()=>null};export{a as countColumn,c as emptyColumn,d as selectionColumn};
